import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
const RestlessImageFormatter = (
  cellContent,
  row,
  rowIndex,
  { verificationToken, profileToken, openImageDialog }
) => {
  const newString = verificationToken
    ? row.picture?.url + verificationToken
    : (row.restless_user?.picture?.url
        ? row.restless_user?.picture?.url
        : cellContent?.thumbnail?.url) + profileToken;

  return (
    <>
      {cellContent ? (
        <img
          onClick={() => openImageDialog(row)}
          alt=""
          style={{ width: "50px", height: "50px", cursor: "pointer" }}
          src={newString}
        />
      ) : (
        <>
          {row.ext === ".mp4" ? (
            <div
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
              }}
            >
              <SVG
                onClick={() => openImageDialog(row)}
                src={toAbsoluteUrl("/media/svg/icons/Media/Movie-Lane2.svg")}
              />
            </div>
          ) : (
            <>
              <SVG src={toAbsoluteUrl("/media/svg/icons/Layout/NoImg.svg")} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default RestlessImageFormatter;
